import { CommonModule, DatePipe, DecimalPipe } from "@angular/common";
import { NgModule } from "@angular/core";

import { DateRangePipe } from "./date-range.pipe";
import { MonthPipe } from "./month.pipe";
import { PickAllPipe } from "./pick-all.pipe";
import { UnitPipe } from "./unit.pipe";

@NgModule({
  declarations: [UnitPipe, DateRangePipe, PickAllPipe, MonthPipe],
  imports: [CommonModule],
  exports: [UnitPipe, DateRangePipe, PickAllPipe, DatePipe, MonthPipe],
  providers: [DecimalPipe, DatePipe],
})
export class PipesModule {}
